export default "__VITE_ASSET__CSp5yE17__"